(() => {
  class ProductBadges extends HTMLElement {
    connectedCallback() {
      this.saleBadge = this.querySelector('[data-product-sale-badge]');
      this.stockBadge = this.querySelector('[data-product-stock-badge]');
      this.staticBadgeCount = Number(this.dataset.staticBadgeCount || 0);
      this.onVariantChange = this.onVariantChange.bind(this);

      document.addEventListener('product:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      const eventScope = event.detail && event.detail.scope;

      if (!variant) return;
      if ((eventScope || this.scope) && eventScope !== this.scope) return;

      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (this.saleBadge) {
        this.saleBadge.hidden = !isOnSale;
      }

      if (this.stockBadge) {
        this.stockBadge.hidden = !variant.available || this.staticBadgeCount + (isOnSale ? 1 : 0) >= 5;
      }
    }

    get scope() {
      return this.dataset.productUiScope || this.closest('.product-layout, .featured-product-showcase, [data-search-product-drawer]') || '';
    }
  }

  if (!customElements.get('product-badges')) {
    customElements.define('product-badges', ProductBadges);
  }
})();
